import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class NavigationSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'navigation');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [

            this.comboField('size', {
                'Hidden': 'hidden',
                'Auto': 'auto',
                'Compact': 'compact',
                'Expanded': 'expanded',
            }),
            this.comboField('position', {
                'Left': 'left',
                'Right': 'right',
            }),

            this.fontFamilyField('font.family', ['main', 'content', 'header']),
            this.sizeNumberField('font.size'),
            this.fontWeightField('font.weight', ['main', 'content']),
            this.fontColorComboField('font.color', ['main', 'content', 'header']),
            this.fontTransformField('font.transform'),

            this.backgroundColorField('background.color', ['main', 'content']),
            this.borderColorField('border.color', ['main', 'content']),
            this.sizeNumberField('border.width', 'px'),

            this.fontColorComboField('subnav.font.color', ['main', 'content', 'header']),
            this.backgroundColorField('subnav.background.color', ['main', 'content']),

            this.comboField('active.style', {
                'Background': 'background',
                'Left': 'left-border',
                'Right': 'right-border',
            }),
            this.fontColorComboField('active.font.color', ['main', 'content', 'header'], { 'Primary Contrast': 'var(--color-primary-contrast)' }),
            this.backgroundColorField('active.background.color', ['main', 'content'], { 'Primary': 'var(--color-primary-color)' }),


            this.sizeNumberField('separator.width', 'px'),

            this.backgroundColorField('logo.background.color', ['navigation', 'main', 'content']),


        ];
    }

}
